import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';

export const useInsight = () => {
	const route = useCurrentRoute();

	if (route.navigation) {
		return route.navigation.menuId === 'INSIGHT';
	}

	return false;
};

export const useInsightObjectSchemaSidebar = () => {
	return false;
};
